import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { IonicModule } from '@ionic/angular';
import { DetailsChangesComponent } from './details-changes.component';
import { TranslateModule } from '../../../../shared/translate/translate.module';
import { AlertCommentDetailsModule } from '../../../alert/details/comment/details/alert-comment-details.module';

@NgModule({
  imports: [CommonModule, IonicModule, TranslateModule, AlertCommentDetailsModule],
  declarations: [DetailsChangesComponent],
  exports: [DetailsChangesComponent]
})
export class DetailsChangesModule { }
